import { Component, computed, input, output } from '@angular/core';

export type TSearchTermSelected = {
  searchTerm: string;
  type: "recent" | "popular";
}

@Component({
  selector: 'app-item-search',
  templateUrl: './item-search.component.html',
  styleUrls: ['./item-search.component.scss'],
  standalone: true,
})
export class ItemSearchComponent  {
  public title = computed(() => {
    return this.type() === "recent" ? "Recent searches" : "Popular searches";
  });

  public type = input<"recent" | "popular">("popular");
  public items: string[] = ["panadol","nurofen", "cough syrup","imodium","bloating","headache","fever","sore throat"];
  public searchSelect = output<TSearchTermSelected>();

  selectSearchTerm(searchTerm: string) {
    this.searchSelect.emit({ searchTerm, type: this.type() });
  }


}